export default (props, request)=> {
    /* 股票图表分时数据 */
    const getChartData = async (stock) => {
        const params = {
            symbol: stock.symbol,
            stock_id: stock.stockId,
            market_code: stock.marketCode,
            type: 1,
            // 0代表 盘中数据
            req_section: 0
        };
        const r = await request.get('quote-minute', params);
        r.price_direct = stock.priceDirect;
        return r;
    };
    /* 股票图表Kline数据 */
    const getKlineData = async (stock) => {
        const params = {
            increaseType: props.increaseType,
            stock_id: stock.stockId,
        };
        const r = await request.get('quote-kline', params);
        return r;
    };

    return {
        getChartData,
        getKlineData
    };
};
